import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Button from './components/Button/Button';
import './mainStyle.css'
import {BrowserRouter as Router, Routes, Route, Link} from 'react-router-dom'
import MainPage from './components/Pages/MainPage/MainPage';
import Configure from './components/Pages/Configure/Configure';

function App() {

  return (
    <div className="App">
      <Header/>
      <Footer/>
    </div>
  );
}

export default App;



// useEffect(() => {
//   try{
//     fetch('http://localhost:8000/api/idParaments', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(query),
//     })
//     .then(res => res.text())
//     .then(
//       (result) => {
//         setData(result)
//       }
//     )
//   } catch (e) {
//       console.log(e)
//   }
// }, [])

// const query = {
//   id:1
// }